/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { Grid, FormControl, FormLabel, FormControlLabel, Radio, RadioGroup, Paper } from '@material-ui/core';
import { EffectCalculatorField } from './EffectCalculatorField';
import * as Player from '../model/Player';
import * as Ledger from '../model/Ledger';
import { AppContext } from '../App';
import { makeStyles } from '@material-ui/styles';
import * as ShortcutManager from '../model/ShortcutManager';

const useStyle = makeStyles({
    root: {
        padding: "1em",
        margin: "1em"
    }
})

export interface EffectCalculatorProps {
    leftLedger: Ledger.Model;
    rightLedger: Ledger.Model;
    setLeftLedger: Function;
    setRightLedger: Function;
}

export const EffectCalculator = (props: EffectCalculatorProps) => {
    const classes = useStyle();
    const context = React.useContext(AppContext);
    const focusRef = React.useRef<HTMLInputElement>();
    const [playerEffected, setPlayerEffected] = React.useState<Player.Position>(Player.Position.LEFT);
    
    const handlePlayerSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPlayerEffected(Number(event.currentTarget.value) as Player.Position);
    }

    const getPlayerEffectedLedger = (): Ledger.Model => {
        return playerEffected === Player.Position.LEFT ? props.leftLedger : props.rightLedger;
    }

    const getPlayerEffectedSetLedger = (): Function => {
        return playerEffected === Player.Position.LEFT ? props.setLeftLedger: props.setRightLedger;
    }

    ShortcutManager.register('e', () => {
        if(focusRef.current !== undefined) {
            focusRef.current.focus();
        }
    });

    return (
        <Paper className={classes.root}>
            <Grid container justify="center" alignItems="center">
                <Grid item xs={12}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Apply effect against:</FormLabel>
                        <RadioGroup row aria-label="" name="player" value={playerEffected} onChange={handlePlayerSwitch}>
                            <FormControlLabel value={Player.Position.LEFT} control={<Radio />} label={context.leftPlayer.name} />
                            <FormControlLabel value={Player.Position.RIGHT} control={<Radio />} label={context.rightPlayer.name} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <EffectCalculatorField focusRef={focusRef} playerPos={playerEffected} playerLedger={getPlayerEffectedLedger()} setLedger={getPlayerEffectedSetLedger()} />
                </Grid>
            </Grid>
        </Paper>
    );
}
